import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatorService } from '../../../services/translate.service';
import { UserSessionService } from '../../../services/user-session.service';

@Component({
  selector: 'app-change-company-modal',
  templateUrl: './change-company-modal.component.html',
  styleUrls: ['./change-company-modal.component.scss']
})
export class ChangeCompanyModal implements OnInit {

  confirmButtonLabel: any = 'LABEL.SAVE'
  cancelButtonLabel: any = 'LABEL.CANCEL'
  form: FormGroup
  respComm: any = []
  localData: any
  companies: any = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private translate: TranslatorService,
    private userSessionService: UserSessionService,
  ) {
    let formStructure: any = {}

    if (data) {
      this.localData = data
      formStructure['company'] = [null, Validators.required]
      
      if (data.companies) {
        this.companies = data.companies
      }else{
        this.getCurrentUserCompanies()
      }

      this.form = this.fb.group(formStructure)
    }

  }

  getLabel(type: any) {

    switch (type) {
      case 'titleLabel':
        return this.translate.instant('LABEL.modificaSedeDellaPratica');
      case 'textLabel':
        return '';
      default:
        break;
    }
    return '';
  }

  ngOnInit(): void {
  }

  disabledConfirmButton() {
    let disabled = false
    if (!this.form.valid) disabled = true
    return disabled
  }

  getLabelSelect() {
    return this.translate.instant('LABEL.HEAD_OFFICES');
  }

  getCurrentUserCompanies() {
    const companiesUser = this.userSessionService.getCompanies();
    this.companies = companiesUser.filter((company:any) => company?.type != 'DR' && company?.isOpen == true)
}

}
